export enum FundRaiserRedirectType {
  None = "None",
  FundRaiser = "FundRaiser",
  Website = "Website",
  MobilePage = "MobilePage",
}
export enum RedirectOtherFundraiserType {
  ClosestGoal = "ClosestGoal",
  AnyActive = "AnyActive",
  Specific = "Specific",
  Gallery = "Gallery",
  MobilePage = "MobilePage",
  Website = "Website",
}

export enum FundRaiserTemplateLayoutType {
  Layout1 = "Layout1",
  Layout2 = "Layout2",
  Layout3 = "Layout3",
  Layout4 = "Layout4",
  Layout5 = "Layout5",
}
export enum ColorSwatches {
  Default = "Default",
  Ocean = "Ocean",
  Forest = "Forest",
  Sunset = "Sunset",
  Purple = "Purple",
  Pink = "Pink",
  Custom = "Custom",
}
export enum IconType {
  None = "None",
  Icon = "Icon",
  Image = "Image",
}

export enum FundRaiserStatus {
  Draft = "Draft",
  Active = "Active",
  Inactive = "Inactive",
  Completed = "Completed",
}
export enum LegalTermsAndConditionType {
  None = "None",
  ReferenceURL = "ReferenceURL",
  CustomTerms = "CustomTerms",
}

export enum GalleryDisplayFundraisersType {
  AllActive = "AllActive",
  AllActiveStarted = "AllActiveStarted",
  AllActiveStarting = "AllActiveStarting",
  RecentlyAdded = "RecentlyAdded",
  Specific = "Specific",
}

export enum DonationPopupModalType {
  Simple = "Simple",
  DonationItem = "DonationItem",
}

export enum FundraiserUnavailableRedirectType {
  Gallery = "Gallery",
  ClosestGoal = "ClosestGoal",
  AnyActive = "AnyActive",
  Specific = "Specific",
  MobilePage = "MobilePage",
  Website = "Website",
}

export enum SystemItemTypes {
  Product = "Product",
  Membership = "Membership",
  Service = "Service",
  Donation = "Donation",
}

export enum FundraiserEmbedViewType {
  Card = "card",
  CTA = "cta",
  Button = "button",
  Form = "form",
}